/**
 * 第三方图床 URL → Cloudflare R2 公开镜像 URL
 * Key 规则与 scripts/sync-images-to-r2.js 中 urlToR2Key 一致
 */

export const R2_PUBLIC_BASE = "https://img.heicreative.co.uk";

/** 本会话内已成功 fallback 的 URL：原地址 → R2 地址 */
const fallbackCache = new Map();

export function isR2MirrorUrl(url) {
    if (!url) {
        return false;
    }
    try {
        return new URL(url).hostname === new URL(R2_PUBLIC_BASE).hostname;
    } catch {
        return false;
    }
}

/**
 * @param {string} originalUrl
 * @returns {string|null}
 */
export function toR2MirrorUrl(originalUrl) {
    if (!originalUrl || isR2MirrorUrl(originalUrl)) {
        return null;
    }
    try {
        const parsed = new URL(originalUrl);
        return `${R2_PUBLIC_BASE}/${parsed.hostname}${parsed.pathname}`;
    } catch {
        return null;
    }
}

export function markFallbackUsed(originalUrl, mirrorUrl) {
    fallbackCache.set(originalUrl, mirrorUrl);
    console.warn("[image-fallback] R2:", originalUrl, "→", mirrorUrl);
}

export function getResolvedImageSrc(originalUrl) {
    return fallbackCache.get(originalUrl) || originalUrl;
}

export function urlToR2Key(url) {
    const parsed = new URL(url);
    return `${parsed.hostname}${parsed.pathname}`;
}
